import { Brand } from "../brand.model.ts";
import { BaseSerializer } from "./baseSerializer.ts";

export class BrandSerializer extends BaseSerializer {

    public deserialize( data: any ): any {
        const gp = new Brand();
        this._copyAttributes(gp, data);
        return gp;

    }

}
